import { getRequestOptionDemoMode } from '@/utils/demoMode';
import { getStorageCompanyId } from '@/utils/localStorage';
import { request } from 'umi';

export async function downloadPerformance(params: API.PerformanceDownloadParametersType) {
  const companyId = getStorageCompanyId();
  return request<API.DownloadType>('/performance/download', {
    responseType: 'blob',
    params: { ...params, companyId },
    skipErrorMessage: true,
  });
}

export async function getOverviewAPI(
  params: API.OverviewGetParameters,
  options?: API.RequestOptions,
) {
  const companyId = getStorageCompanyId();
  return request<API.Overview>('/performance/overview', {
    params: { ...params, companyId },
    ...options,
    ...getRequestOptionDemoMode(),
  });
}

export async function getPageViewAPI(
  params: API.PageViewGetParameters,
  options?: API.RequestOptions,
) {
  const companyId = getStorageCompanyId();
  return request<API.PageView>('/performance/page_view', {
    params: { ...params, companyId },
    ...options,
    ...getRequestOptionDemoMode(),
  });
}

export async function getPageViewAllAPI(
  params: API.PageViewAllGetParameters,
  options?: API.RequestOptions,
) {
  const companyId = getStorageCompanyId();
  return request<API.PageViewAll>('/performance/page_view/all', {
    params: { ...params, companyId },
    ...options,
  });
}

export async function getSessionAPI(params: API.SessionGetParameter, options?: API.RequestOptions) {
  const companyId = getStorageCompanyId();
  return request<API.Session>('/performance/session', {
    params: { ...params, companyId },
    ...options,
    ...getRequestOptionDemoMode(),
  });
}

export async function getSessionAllAPI(
  params: API.SessionAllGetParameters,
  options?: API.RequestOptions,
) {
  const companyId = getStorageCompanyId();
  return request<API.SessionAll>('/performance/session/all', {
    params: { ...params, companyId },
    ...options,
  });
}

export async function getEngagementRateAPI(
  params: API.EngagementRateGetParameters,
  options?: API.RequestOptions,
) {
  const companyId = getStorageCompanyId();
  return request<API.EngagementRate>('/performance/engagement_rate', {
    params: { ...params, companyId },
    ...options,
    ...getRequestOptionDemoMode(),
  });
}

export async function getEngagementRateAllAPI(
  params: API.EngagementRateAllGetParameters,
  options?: API.RequestOptions,
) {
  const companyId = getStorageCompanyId();
  return request<API.EngagementRateAll>('/performance/engagement_rate/all', {
    params: { ...params, companyId },
    ...options,
  });
}

export async function getChannelGroupApi(
  params: API.ChannelGroupGetParameters,
  options?: API.RequestOptions,
) {
  const companyId = getStorageCompanyId();
  return request<API.ChannelGroup>('/performance/channel_group', {
    params: { ...params, companyId },
    ...options,
    ...getRequestOptionDemoMode(),
  });
}

export const getSourceMediumApi = async (
  params: API.SourceMediumGetParameters,
  options?: API.RequestOptions,
) => {
  const companyId = getStorageCompanyId();
  return request<API.SourceMedium>('/performance/source_medium', {
    params: { ...params, companyId },
    ...options,
    ...getRequestOptionDemoMode(),
  });
};

export const getAudienceApi = async (
  params: API.AudienceGetParameters,
  options?: API.RequestOptions,
) => {
  const companyId = getStorageCompanyId();
  return request<API.Audience>('/performance/audience', {
    params: { ...params, companyId },
    ...options,
    ...getRequestOptionDemoMode('audienceName'),
  });
};
